import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { CostCenter } from '../models/cost-center.model';
import { environment } from '../../environments/environment';

export interface CreateCostCenterDto {
  name: string;
  description?: string;
  serviceGroupId?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class CostCenterService {
  private apiUrl = `${environment.apiUrl}/CostCenter`;

  constructor(private http: HttpClient) { }

  getAllCostCenters(): Observable<CostCenter[]> {
    return this.http.get<CostCenter[]>(this.apiUrl).pipe(retry(2));
  }

  addCostCenter(costCenter: CostCenter): Observable<CostCenter> {
    const createDto: CreateCostCenterDto = {
      name: costCenter.name,
      description: costCenter.description,
      serviceGroupId: costCenter.serviceGroupId || null
    };
    return this.http.post<CostCenter>(this.apiUrl, createDto);
  }

  updateCostCenter(id: string, costCenter: CostCenter): Observable<CostCenter> {
    return this.http.put<CostCenter>(`${this.apiUrl}/${id}`, costCenter);
  }
}


